import React from 'react'
import { User, Bot, Settings, Eye, FileText, Coins, DollarSign } from 'lucide-react'
import { ConversationMessageViewProps } from '../types/conversationDetail'

const ConversationMessageView: React.FC<ConversationMessageViewProps> = ({ 
  message, 
  onShowPrompt, 
  onShowMessages 
}) => {
  const formatTime = (date: Date): string => {
    return new Date(date).toLocaleString('es-ES', {
      year: 'numeric',
      month: '2-digit', 
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  const getMessageIcon = () => {
    switch (message.type) {
      case 'user': return <User size={16} />
      case 'assistant': return <Bot size={16} />
      case 'tool_call': return <Settings size={16} />
      default: return <Bot size={16} />
    }
  }

  const getMessageClass = () => {
    switch (message.type) {
      case 'user': return 'message-user'
      case 'assistant': return 'message-assistant'
      case 'tool_call': return 'message-tool'
      default: return 'message-assistant'
    }
  }

  const getMessageLabel = () => {
    switch (message.type) {
      case 'user': return 'Usuario'
      case 'assistant': return 'Asistente'
      case 'tool_call': return 'Tool Call'
      default: return 'Mensaje'
    }
  }

  return (
    <div className={`conversation-message ${getMessageClass()}`}>
      <div className="message-header">
        <div className="message-type">
          {getMessageIcon()}
          <span>{getMessageLabel()}</span>
        </div>
        
        <div className="message-meta">
          {message.model && (
            <span className="model-badge">{message.model}</span>
          )}
          <span className="message-time">{formatTime(message.createdAt)}</span>
        </div>
      </div>

      <div className="message-content">
        {message.content}
      </div>

      {(message.inputTokens > 0 || message.outputTokens > 0 || message.cost > 0) && (
        <div className="message-stats">
          {message.inputTokens > 0 && (
            <span className="stat">
              <Coins size={12} />
              In: {message.inputTokens}
            </span>
          )}
          {message.outputTokens > 0 && (
            <span className="stat">
              <Coins size={12} />
              Out: {message.outputTokens}
            </span>
          )}
          {message.cost > 0 && (
            <span className="stat">
              <DollarSign size={12} />
              €{message.cost.toFixed(4)}
            </span>
          )}
        </div>
      )}

      {(message.promptData || message.messagesData) && (
        <div className="message-actions">
          {message.promptData && (
            <button 
              className="action-button"
              onClick={() => onShowPrompt(message.promptData!)}
            >
              <Eye size={14} />
              Ver Prompt
            </button>
          )}
          {message.messagesData && (
            <button 
              className="action-button"
              onClick={() => onShowMessages(message.messagesData!)}
            >
              <FileText size={14} />
              Ver Messages
            </button>
          )}
        </div>
      )}

      {(message.rating || message.review) && (
        <div className="message-feedback">
          {message.rating && (
            <span className="rating">Rating: {message.rating}/5</span>
          )}
          {message.review && (
            <span className="review">"{message.review}"</span>
          )}
        </div>
      )}
    </div>
  )
}

export default ConversationMessageView
